import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Config from './pages/Config';
import DataStats from './pages/DataStats';
import Alerts from './pages/Alerts';
import IntervalsConfig from './pages/IntervalsConfig';
import SamsaraConfig from './pages/SamsaraConfig';
import Library from './pages/Library';
import Health from './pages/Health';
import Capturas from './pages/Capturas';
import PanelAlarmas from './pages/PanelAlarmas';
import Accesos from './pages/Accesos';
import MdvrWifi from './pages/MdvrWifi';
import Apagado from './pages/Apagado';
import VmsPared from './pages/VmsPared';
import Live from './pages/Live';
import Recordings from './pages/Recordings';
import Videos from './pages/Videos';
import Usuarios from './pages/Usuarios';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div style={{height:'100vh',display:'flex',alignItems:'center',justifyContent:'center'}}>Cargando...</div>;
  if (!user) return <Navigate to="/login" />;
  return children;
};

const App = () => (
  <AuthProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index            element={<Dashboard />} />
          <Route path="live"       element={<Live />} />
          <Route path="recordings" element={<Recordings />} />
          <Route path="videos"     element={<Videos />} />
          <Route path="config"    element={<Config />} />
          <Route path="stats"     element={<DataStats />} />
          <Route path="alerts"    element={<Alerts />} />
          <Route path="intervals" element={<IntervalsConfig />} />
          <Route path="samsara"   element={<SamsaraConfig />} />
          <Route path="library"   element={<Library />} />
          <Route path="health"    element={<Health />} />
          <Route path="capturas"  element={<Capturas />} />
          <Route path="panel"      element={<PanelAlarmas />} />
          <Route path="accesos"    element={<Accesos />} />
          <Route path="mdvr-wifi"  element={<MdvrWifi />} />
          <Route path="apagado"    element={<Apagado />} />
          <Route path="vms"        element={<VmsPared />} />
          <Route path="usuarios"   element={<Usuarios />} />
        </Route>

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  </AuthProvider>
);

export default App;